export const iconFontAwesomeMediaplaybackDownLeftAndUpRightToCenter = (
	<i className="fa-solid fa-down-left-and-up-right-to-center"></i>
);
